import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './objectMenuStyles.module.css';
import classNames from 'classnames';
import { makeTestId } from '../../utils/tools';

interface Props {
  title: string;
  className?: string;
  onClick(): void;
}

const SectionButton: React.FC<Props> = ({ title, className, onClick }) => {
  return (
    <div
      className={classNames(styles.objectMenuSectionButton, className)}
      onClick={onClick}
      data-testid={makeTestId(title)}
    >
      {title}
      <aha-icon icon='fa-regular fa-arrow-right' />
    </div>
  );
};

export default ApplicationView(SectionButton);
